import React from 'react';
import { graphql, useFragment } from 'react-relay';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import BitbucketBuildsIcon from '@atlaskit/icon/glyph/bitbucket/builds';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { failedBuild_periscope_FailedBuildTask$key } from '@atlassian/jira-relay/src/__generated__/failedBuild_periscope_FailedBuildTask.graphql';
import { FailedInfo } from '../../../common/ui/failed-info';
import { TaskItem } from '../../../common/ui/task-item';
import { TaskTypeItem } from '../../../common/ui/task-type';
import { useWorkSuggestionsContainer } from '../../../services/periscope-container';
import { useWorkSuggestionsAction } from '../../../services/use-work-suggestions-action';
import { messages } from './messages';

export const FailedBuildTask = ({
	fragmentRef,
}: {
	fragmentRef: failedBuild_periscope_FailedBuildTask$key;
}) => {
	const { formatMessage } = useIntl();
	const data = useFragment(
		graphql`
			fragment failedBuild_periscope_FailedBuildTask on WorkSuggestionsBuildTask {
				__typename
				id
				url
				title
				issueKey
				lastUpdated
			}
		`,
		fragmentRef,
	);
	const { snooze, remove } = useWorkSuggestionsAction();
	const [{ showReactionsButtonForSuggestions }, { hideSuggestionsReactionsButton }] =
		useWorkSuggestionsContainer();

	return (
		<TaskTypeItem
			onRemove={() => remove({ id: data.id, typename: data.__typename })}
			onSnooze={() => snooze({ id: data.id, typename: data.__typename })}
			url={data.url}
			suggestionType={data.__typename}
			id={data.id}
			showReactionsButton={
				showReactionsButtonForSuggestions[data.id] === true ||
				showReactionsButtonForSuggestions[data.id] == null
			}
			onReactionsButtonClick={() => hideSuggestionsReactionsButton(data.id)}
			actionButtonTitle={formatMessage(messages.actionButtonNonFinal)}
		>
			<TaskItem
				taskInfoContent={
					<FailedInfo
						title={data.title}
						issueKey={data.issueKey}
						lastUpdated={data.lastUpdated}
						icon={
							<CrossCircleIcon
								LEGACY_fallbackIcon={BitbucketBuildsIcon}
								LEGACY_size="medium"
								label="build icon"
								color={token('color.icon.warning')}
							/>
						}
					/>
				}
			/>
		</TaskTypeItem>
	);
};
